// hooks/useRating.js
import { useState, useEffect } from "react";
import { toast } from "sonner";
import axiosInstance from "../api/axiosInstance";
import { ENDPOINTS } from "../api/endpoints";

export const useRating = (taskId, enabled) => {
  const [driverRating, setDriverRating] = useState("");
  const [customerMessage, setCustomerMessage] = useState("");

  const [ratingSubmitting, setRatingSubmitting] = useState(false);
  const [ratingSubmitted, setRatingSubmitted] = useState(false);
  const [existingRating, setExistingRating] = useState(null);
  const [loadingRating, setLoadingRating] = useState(false);
  const [ratingDismissed, setRatingDismissed] = useState(false); 

  //  FETCH EXISTING RATING (ONLY AFTER DELIVERY)
  useEffect(() => {
    if (!taskId || !enabled) return;

    let cancelled = false;

    const fetchRating = async () => {
      try {
        setLoadingRating(true);

        const res = await axiosInstance.post(
          ENDPOINTS.GET_RATING,
          { taskId: String(taskId) }
        );

        if (
          !cancelled &&
          res?.data?.responseCode === "00" &&
          res.data.data
        ) {
          setExistingRating(res.data.data);
          setRatingSubmitted(true);
        }
      } catch (err) {
        console.error("Fetch rating error", err);
      } finally {
        if (!cancelled) setLoadingRating(false);
      }
    };

    fetchRating();

    return () => {
      cancelled = true;
    };
  }, [taskId, enabled]);

  // SUBMIT RATING (delivery ke baad)
  const submitDeliveryRating = async ({ orderDetails }) => {
    if (!driverRating) {
      toast.error("Please select rating");
      return;
    }

    const payload = {
      taskId: String(taskId),
      customerName: orderDetails?.customer_name || "",
      customerMobile: orderDetails?.customer_mobile || "",
      driverRating: String(driverRating),
      customerMessege: customerMessage || "",
    };

    try {
      setRatingSubmitting(true);

      const res = await axiosInstance.post(
        ENDPOINTS.SUBMIT_RATING,
        payload
      );

      if (res?.data?.responseCode === "00") {
        toast.success("Thank you for your feedback");

        setExistingRating({
          rating: driverRating,
          customer_message: customerMessage,
        });

        setRatingSubmitted(true);
      } else {
        toast.error(res?.data?.responseMessage || "Failed to submit rating");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setRatingSubmitting(false);
    }
  };

  const dismissRating = () => {
    setRatingDismissed(true);
  };

  return {
    driverRating,
    setDriverRating,
    customerMessage,
    setCustomerMessage,
    ratingSubmitting,
    ratingSubmitted,
    existingRating,
    loadingRating,
    submitDeliveryRating,
    ratingDismissed, 
    dismissRating, 
  };
};